<template>
<div name="hrms-table" class="wrapper-hrms-table upload-on-table">
  <div class='clearfix top-table'>
    <div class="panel-control">
      <div class="control-search">
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10" @click="eventTrigger('add')" v-if="typeof addEvent !== 'undefined' && addBtnDisp">
          <i class="fa fa-plus-circle"></i>
          <p class="label-btn-table">{{ button[nowLang].add }}</p>
        </div>
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10" @click="addInlineEventBuiltIn()"
             v-if="addInlineEventBool && ((!loadingBool && !preLoadBool) || addPreLoad)">
          <i class="fa fa-plus-circle"></i>
          <p class="label-btn-table">{{ button[nowLang].add }}</p>
        </div>
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10 margin-l-0" @click="deleteInlineEventBuiltIn()"
             v-if="deleteInlineEventBool && deleteInlineBtnDisp && !loadingBool && !preLoadBool" :disabled="true">
          <i class="fa fa-trash"></i>
          <p class="label-btn-table">{{ button[nowLang].delete }}</p>
        </div>
        <div class="control-center" v-if="searchDisp && !loadingBool && !preLoadBool">
          <input class="search-table" type="text" v-model="inputSearch" @keyup="currentPage = 1" placeholder="Search" />
          <!-- <input class="search-table" type="text" v-model="inputSearch" @keyup="currentPage = 1" placeholder="Search" :disabled="searchBool" /> -->
        </div>
      </div>
      <!-- <pdf-exporter :dataRows="dataTableRows" v-show="pdfExportDisp && !loadingBool && !preLoadBool" /> -->
      <csv-exporter :dataRows="dataTableRows" :columns="columns" v-show="csvExportDisp && !loadingBool && !preLoadBool" />
    </div>
  </div>

  <div class="table-hrms table-main clearfix" :class="[(loadingBool || preLoadBool) ? 'loading' : '', (addInlineEventBool || editInlineEventBool || deleteInlineEventBool) ? 'table-inline' : '']">
    <table>
      <thead>
        <tr v-for="(headerRow, headerRowIndex) in maxRowspan" :key="headerRowIndex" v-if="filterHeaderColumns(columns, headerRow).length > 0">
          <template v-if="headerRow == 1">
            <th :rowspan="maxRowspan" v-if="typeof tickEvent !== 'undefined'">{{button[nowLang].select}}</th>
            <th :rowspan="maxRowspan"><i class="fa fa-hashtag" v-if="indexDisp"></i></th>
            <th v-if="typeof selectEvent !== 'undefined' && selectBtnDisp" :rowspan="maxRowspan" style="min-width: 90px">
              <template v-if="!selectRowBool">
                <div @click="countSelect()" :class="[ selectBtn == 0 ? 'select-none' : 'select-checked' ]" class="cursor-pointer">
                  <i :class="'fa fa-' + [ selectBtn == 0 ? 'circle-o-notch' : 'ban' ]" class="icon-status"></i>{{selectDesc}}
                </div>
              </template>
              <template v-else>
                Select
              </template>
            </th>
            <th v-if="typeof approveEvent !== 'undefined' && approveBtnDisp" :rowspan="maxRowspan" style="min-width: 90px">
              <template v-if="!approveRowBool">
                <div @click="countStaappr()" :class="[ staapprBtn == 0 ? 'sta-none' : staapprBtn == 1 ? 'sta-approve' : 'sta-reject' ]" class="cursor-pointer">
                  <i :class="'fa fa-' + [ staapprBtn == 0 ? 'circle-o-notch' : staapprBtn == 1 ? 'check-circle' : 'ban' ]" class="icon-status"></i>{{statusBtn}}
                </div>
              </template>
              <template v-else>
                Select
              </template>
            </th>
            <th :rowspan="maxRowspan" v-if="typeof detailEvent !== 'undefined'">{{button[nowLang].detail}}</th>
            <th :rowspan="maxRowspan" v-if="typeof editEvent !== 'undefined'">{{button[nowLang].edit}}</th>
            <th :rowspan="maxRowspan" v-if="typeof cancelEvent !== 'undefined'">{{button[nowLang].cancel}}</th>
            <th :rowspan="maxRowspan" v-if="deleteInlineEventBool">
              <div @click="toggleDelete(!deleteIconBool)" :class="[ deleteIconBool ? 'main-del-checked' : 'main-del-unchecked' ]" class="cursor-pointer">
                <i :class="'fa fa-' + [ deleteIconBool ? 'trash' : 'trash-o' ]" class="icon-delete-desc"></i>
              </div>
            </th>
            <template v-if="typeof multiSelect == 'boolean'">
              <th v-if="multiSelect" :rowspan="maxRowspan"><input type="checkbox" v-model="checkedAll"/></th>
              <th v-if="!multiSelect" :rowspan="maxRowspan"><i class="fa fa-circle-o"></i></th>
            </template>
          </template>
          <template v-for="(column, columnIndex) in filterHeaderColumns(columns, headerRow)">
            <sort-column  :key="columnIndex"
                          :column="column"
                          :sortDisp="sortDisp"
                          @resetOthersColumnSortKey="resetOthersColumnSortKey(arguments[0])" />
          </template>
        </tr>
      </thead>
      <tbody v-if="(!loadingBool && !preLoadBool) || addPreLoad">
        <template v-if="dataTableTotal > 0">
          <template v-for="(dataRow, rowIndex) in dataTableRows">
              <tr v-if="rowIndex + 1 >= startRow && rowIndex + 1 <= endRow" :key="rowIndex"
                  :class="[ ( rowIndex + 1 )  % 2 == 0 ? 'even' :  'odd',
                            (dataRow.flgDelete && deleteInlineEventBool && !dataRow.flgAdd) ? 'flg-inline delete' : '',
                            (rowClassCondition) ? rowClassCondition(dataRow) : '' ]">
                <input type="hidden" :name="'flgEdit' + rowIndex" :value="dataRow.flgEdit ? 'Y' : ''" />
                <td class="align-center" v-if="typeof tickEvent !== 'undefined'">
                  <div class="button-in-td cursor-pointer button-select-item">
                    <i class="fa fa-check-circle text-green" @click="eventTrigger('tick', dataRow)"></i>
                  </div>
                </td>
                <td class="align-center">
                  <div :class="[ dataRow.flgEdit && !dataRow.flgAdd && !dataRow.flgDelete && editInlineEventBool ? 'flg-inline edit' : (dataRow.flgAdd && addInlineEventBool && !dataRow.flgDelete) ? 'flg-inline add' : '' ]"></div>
                  <template v-if="indexDisp">{{ rowIndex + 1 }}</template>
                </td>
                <td v-if="typeof selectEvent !== 'undefined' && selectBtnDisp">
                  <template v-if="!selectRowBool">
                    <select-button v-model="dataRow.flgSelect" :selectDesc="dataRow.select"/>
                  </template>
                  <template v-else>
                    <select-button v-model="dataRow.flgSelect" :selectDesc="dataRow.select" @setDefaultSelect="selectAllSelectInPage('N')" :selectRowBool="true" />
                  </template>
                </td>
                <td v-if="typeof approveEvent !== 'undefined' && approveBtnDisp">
                  <template v-if="!approveRowBool">
                    <staappr-button :disable="rowDisableConditionBuiltIn(dataRow)" v-model="dataRow.flgStaappr" :staappr="dataRow.staappr"/>
                  </template>
                  <template v-else>
                    <staappr-button :disable="rowDisableConditionBuiltIn(dataRow)" v-model="dataRow.flgStaappr" :staappr="dataRow.staappr" @setDefaultStatus="selectAllStatusInPage('')" :approveRowBool="true" />
                  </template>
                </td>
                <td v-if="typeof detailEvent !== 'undefined'" class="align-center">
                  <div class="table-button cursor-pointer" @click="detailEventBuiltIn(dataRow)">
                      <i class="fa fa-info-circle icon-detail text-orange"></i>
                  </div>
                </td>
                <td class="align-center" v-if="typeof editEvent !== 'undefined'">
                  <div class="button-in-td cursor-pointer">
                    <i class="fa fa-pencil text-blue" @click="eventTrigger('edit', dataRow)"></i>
                  </div>
                </td>
                <td class="align-center" v-if="typeof cancelEvent !== 'undefined'">
                  <div class="button-in-td cursor-pointer">
                    <i class="fa fa-times-circle text-red" @click="eventTrigger('cancel', dataRow)"></i>
                  </div>
                </td>
                <td class="align-center" v-if="deleteInlineEventBool">
                  <delete-button :disable="rowDisableConditionBuiltIn(dataRow) || (deleteInlineBtnDisabledOlds && !dataRow.flgAdd)" v-model="dataRow.flgDelete" />
                </td>
                <template v-if="typeof multiSelect == 'boolean'">
                  <td v-if="multiSelect" class="align-center"><input type="checkbox" :value="dataRow" v-model="selectedRows" /></td>
                  <td v-if="!multiSelect" class="align-center"><input type="radio" :value="dataRow" v-model="selectedRows" /></td>
                </template>
                <template v-for="(column, columnIndex) in filterBodyColumns">
                  <td :key="columnIndex" :class="[ (typeof column.class !== 'undefined') ? column.class : '', (typeof column.columnClassCondition === 'function') ? column.columnClassCondition(dataRow, column.key, rowIndex) : '' ]">
                    <template v-if="typeof column.inlineType == 'undefined' || (typeof column.columnDisabledCondition !== 'undefined' && column.columnDisabledCondition(dataRow, column.key, rowIndex))">
                      <template v-if="typeof column.tagType == 'undefined'">
                        <template v-if="typeof column.eventName == 'undefined'">{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                        <template v-else>
                          <div>
                            <a href="#" @click="columnEvent(column.eventName, dataRow, $event)">
                              <template v-if="typeof column.eventIcon !== 'undefined'">
                                <i :class="'fa fa-' + column.eventIcon"></i>
                              </template>
                              <template>{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                            </a>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="column.tagType == 'path_link'">
                          <div>
                            <a :href="(typeof dataRow.path_link !== 'undefined') ? dataRow.path_link : '#'" target="_blank" >{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</a>
                          </div>
                        </template>
                        <template v-else-if="column.tagType == 'file'">
                          <div>
                            <a :href="(typeof dataRow.path_filename !== 'undefined') ? dataRow.path_filename : '#'" download>{{ dataRow[column.key] }}</a>
                          </div>
                        </template>
                        <template v-else-if="column.tagType == 'upload'">
                            <div>
                              <a :href="(typeof dataRow.path_filename !== 'undefined') ? dataRow.path_filename : '#'" target="_blank" >{{ dataRow[column.key] }}</a>
                            </div>
                          </template>
                        <template v-else-if="column.tagType == 'image'">
                          <template v-if="dataRow[column.key]">
                            <image-gallery :imageSrc="dataRow[column.key]" />
                          </template>
                        </template>
                        <template v-else>{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="(!dataRow.flgAdd && !editInlineEventBool) || (!dataRow.flgAdd && column.inlineFlgEditDisabled) || dataRow.flgDelete || rowDisableConditionBuiltIn(dataRow)">
                        <template v-if="typeof column.tagType == 'undefined'">
                          <template v-if="column.inlineType == 'select' && typeof column.inlineDropdown != 'undefined'">{{ dataRow[column.key] }} - {{ column.inlineDropdown[dataRow[column.key]] }}</template>
                          <template v-else>{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                        </template>
                        <template v-else>
                          <template v-if="column.tagType == 'path_link'">
                            <div>
                              <a :href="(typeof dataRow.path_link !== 'undefined') ? dataRow.path_link : '#'" target="_blank" >{{ dataRow[column.key] }}</a>
                            </div>
                          </template>
                          <template v-else-if="column.tagType == 'file'">
                            <div>
                              <a :href="(typeof dataRow.path_filename !== 'undefined') ? dataRow.path_filename : '#'" download>{{ dataRow[column.key] }}</a>
                            </div>
                          </template>
                          <template v-else-if="column.tagType == 'upload'">
                            <div>
                              <a :href="(typeof dataRow.path_filename !== 'undefined') ? dataRow.path_filename : '#'" target="_blank" >{{ dataRow[column.key] }}</a>
                            </div>
                          </template>
                          <template v-else>{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                        </template>
                        <input type="hidden" :name="column.key + rowIndex" v-model="dataRow[column.key]" />
                      </template>
                      <template v-else>
                        <template v-if="typeof column.tagType == 'undefined'">
                          <template v-if="column.inlineType == 'text'">
                            <input  @keyup="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                    @change="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event, column.key, rowIndex)"
                                    @focusout="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                    @focusin="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                    v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                    :data-vv-as="column.key"
                                    :name="column.key + rowIndex"
                                    type="text"
                                    :class="(typeof column.class !== 'undefined') ? column.class : ''"
                                    v-model="dataRow[column.key]"
                                    :maxlength="column.maxlength" />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-if="column.inlineType == 'number'">
                            <hrms-num-input @keyup="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                            @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event, column.key, rowIndex)"
                                            v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                            :data-vv-as="column.key"
                                            :name="column.key + rowIndex"
                                            type="text"
                                            :class="(typeof column.class !== 'undefined') ? column.class : ''"
                                            v-model="dataRow[column.key]"
                                            :decimal="column.decimal"
                                            :maxlength="column.maxlength"
                                            :numLength="column.numLength" />
                            <!-- <input  @keyup="columnEvent(column.eventName, dataRow, $event)"
                                    @change="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                    @focusout="columnEvent(column.eventName, dataRow, $event)"
                                    @focusin="columnEvent(column.eventName, dataRow, $event)"
                                    v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                    :data-vv-as="column.key"
                                    :name="column.key + rowIndex"
                                    type="number"
                                    :class="(typeof column.class !== 'undefined') ? column.class : ''"
                                    v-model="dataRow[column.key]" /> -->
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'select'">
                            <hrms-dropdown  @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                            v-model="dataRow[column.key]"
                                            :options="column.inlineDropdown"
                                            v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                            data-vv-value-path="inputValue"
                                            :data-vv-as="column.key"
                                            :data-vv-name="column.key + rowIndex"
                                            :name="column.key + rowIndex"
                                            :has-error="errors.has(column.key + rowIndex)" />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'lov'">
                            <template v-if="column.lovType === 'codcomp'">
                              <hrms-lov-codcomp   @keyup.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                                  @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                                  @changeLov="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                                  @focusout.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                                  @focusin.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                                  :flgInlineTable="true"
                                                  :descDisp="false"
                                                  v-model="dataRow[column.key]"
                                                  :nowLang="nowLang"
                                                  v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                                  data-vv-value-path="inputValue"
                                                  :data-vv-as="column.key + rowIndex"
                                                  :data-vv-name="column.key + rowIndex"
                                                  :name="column.key + rowIndex"
                                                  :has-error="errors.has(column.key + rowIndex)" />
                              <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                            </template>
                            <template v-else>
                              <hrms-lov       @keyup.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                              @changeLov="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                              @focusout.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @focusin.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              :flgInlineTable="true"
                                              :descDisp="false"
                                              v-model="dataRow[column.key]"
                                              :nowLang="nowLang"
                                              :lovType="column.lovType"
                                              v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                              data-vv-value-path="inputValue"
                                              :data-vv-as="column.key + rowIndex"
                                              :data-vv-name="column.key + rowIndex"
                                              :name="column.key + rowIndex"
                                              :has-error="errors.has(column.key + rowIndex)"
                                              :maxlength="column.maxlength" />
                              <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                            </template>
                          </template>
                          <template v-else-if="column.inlineType == 'checkStatus'">
                             <check-status  v-model="dataRow[column.key]"
                                            @submit="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                            v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                            data-vv-value-path="inputValue"
                                            :data-vv-as="column.key"
                                            :data-vv-name="column.key + rowIndex"
                                            :name="column.key + rowIndex"
                                            :has-error="errors.has(column.key + rowIndex)"
                                            :nowLang="nowLang"
                                            />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'textarea'">
                            <div class="td-textarea">
                              <textarea @keyup="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                        @change="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                        @focusout="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                        @focusin="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                        v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                        :data-vv-as="column.key"
                                        :class="[ (typeof column.class !== 'undefined') ? column.class : '', errors.has(column.key + rowIndex) ? 'input-error' : '' ]"
                                        :name="column.key + rowIndex"
                                        v-model="dataRow[column.key]"
                                        :maxlength="column.maxlength" />
                            </div>
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'date'">
                            <hrms-datepicker  @keyup.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                              @changeInputDate="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow)"
                                              @focusout.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @focusin.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              v-model="dataRow[column.key]"
                                              v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                              data-vv-value-path="inputDate"
                                              :data-vv-as="column.key"
                                              :data-vv-name="column.key + rowIndex"
                                              :name="column.key + rowIndex"
                                              :has-error="errors.has(column.key + rowIndex)" />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'time'">
                            <hrms-timepicker  @keyup.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @change.native="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow, $event)"
                                              @changeInputTime="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow)"
                                              @focusout.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              @focusin.native="columnEventBuiltIn(column.eventName, dataRow, $event)"
                                              v-model="dataRow[column.key]"
                                              v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                              data-vv-value-path="inputTime"
                                              :data-vv-as="column.key"
                                              :data-vv-name="column.key + rowIndex"
                                              :name="column.key + rowIndex"
                                              :has-error="errors.has(column.key + rowIndex)" />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                          <template v-else-if="column.inlineType == 'upload'">
                            <!-- <i class="fa fa-cloud-upload" aria-hidden="true"></i> -->
                            <hrms-dropzone  @uploadSuccess="onSelectChangeEditInlineAndColumnEvent(column.eventName, dataRow)"
                                            v-model="dataRow[column.key]"
                                            :fileNameQuery="dataRow[column.key]"
                                            v-validate="findValidateRules(column.validateRules, rowIndex, dataRow, column.key)"
                                            data-vv-value-path="resultFileName"
                                            :flgToggle="flgToggle"
                                            :prefixFileName="typeof dataRow[column.keyCodempid] !== 'undefined' ? dataRow[column.keyCodempid] : codempid"
                                            :data-vv-as="column.key"
                                            :data-vv-name="column.key + rowIndex"
                                            :name="column.key + rowIndex"
                                            :has-error="errors.has(column.key + rowIndex)"
                                            :flgEditInline="true" />
                            <div v-show="errors.has(column.key + rowIndex)" class="text-error">{{ errors.first(column.key + rowIndex) }}</div>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="column.tagType == 'path_link'">
                          INPUT LINK
                        </template>
                        <template v-else-if="column.tagType == 'file'">
                          INPUT FILE
                        </template>
                        <template v-else>{{ getDataRowFromColumnDataType(dataRow[column.key], column.dataType) }}</template>
                      </template>
                    </template>
                  </td>
                </template>
              </tr>
          </template>
          <tr v-if="summaryDisp()">
            <td :colspan="preSummaryColumn" class="even align-right summary-row">{{ summaryLabel }}</td>
            <template v-for="(column, columnIndex) in filterBodyColumns">
              <template v-if="columnIndex >= notPreSummaryColumn">
                <td :key="columnIndex" class="even summary-row" :class="[ column.class ? column.class : 'align-right']" v-if="typeof column.summary !== 'undefined' && column.summary">{{ summaryColumn(column) }}</td>
                <td :key="columnIndex" class="even summary-row" v-else></td>
              </template>
            </template>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="noDataColumn" class="even no-data-found">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;No data found.</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-show="preLoadBool && !addPreLoad" class="infinite-loading-container preLoad">Please fill information to search.</div>
    <div v-show="!preLoadBool && loadingBool" class="infinite-loading-container"><i class="loading-default"></i></div>
  </div>

  <div class='clearfix bottom-table' v-if="!preLoadBool && !loadingBool && tablePageDisp">
    <div class='pull-left paging-left num-show' v-if="dataTableTotal > 0">
      Show {{ startRow }} to {{ endRow }} of {{ dataTableTotal }}
    </div>
    <div class='pull-right paging-right' v-if="dataTableTotal > 0">
      <div class='pull-left panel-perpage-bottom'>
        <select v-model="displayRowSelected" class="select-perpage" :disabled="pageBool">
          <option v-for="(displayRow, displayRowIndex) in displayRowsFilter()" :key="displayRowIndex">{{ displayRow }}</option>
          <option value="999999">all</option>
        </select>
      </div>
      <div class='pull-right panel-paging-bottom cursor-pointer'>
        <div class='paging' @click="setCurrentPage(1)"><i class='fa fa-angle-double-left'></i></div>
        <div class='paging' @click="setCurrentPage(currentPage - 1)"><i class='fa fa-angle-left'></i></div>
        <template v-for="(page, pageIndex) in totalPage">
          <div :key="pageIndex" class='paging' :class="{ 'paging-focus' : page == currentPage }" @click="setPageClicked(page)" v-show="filterPage(page)">{{ page }}</div>
        </template>
        <div class='paging' @click="setCurrentPage(currentPage + 1)"><i class='fa fa-angle-right'></i></div>
        <div class='paging' @click="setCurrentPage(totalPage)"><i class='fa fa-angle-double-right'></i></div>
      </div>
    </div>

    <div class="panel-control" v-show="(!loadingBool && !preLoadBool) || addPreLoad">
      <div class="control-search">
        <div class="control-button bg-dark-gray bg-hover-dark-gray-dark-10" @click="backEvent('index')" v-if="typeof backEvent !== 'undefined'">
          <i class="fa fa-chevron-circle-left"></i>
          <p class="label-btn-table">{{ button[nowLang].back }}</p>
        </div>
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10" @click="saveInlineEventBuiltIn()" v-if="(addInlineEventBool || editInlineEventBool ||deleteInlineEventBool) && saveInlineBtnDisp" :disabled="true">
          <i class="fa fa-check-circle"></i>
          <p class="label-btn-table">{{ button[nowLang].save }}</p>
        </div>
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10" @click="approveEvent(dataTableRows)" v-if="typeof approveEvent !== 'undefined' && approveBtnDisp && approveInlineBtnDisp && dataTableTotal > 0">
          <i class="fa fa-check-circle"></i>
          <p class="label-btn-table">{{ button[nowLang].approve }}</p>
        </div>
        <div class="control-button bg-color-skin bg-hover-color-skin-dark-10" @click="selectEvent(dataTableRows)" v-if="typeof selectEvent !== 'undefined' && confirmSelectBtnDisp && dataTableTotal > 0">
          <i class="fa fa-check-circle"></i>
          <p class="label-btn-table">{{ button[nowLang].select }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import staapprButton from 'components/hrmsTableTemplate/staapprButton'
import selectButton from 'components/hrmsTableTemplate/selectButton'
import deleteButton from 'components/hrmsTableTemplate/deleteButton'
import sortColumn from 'components/hrmsTableTemplate/sortColumn'
import csvExporter from 'components/hrmsTableTemplate/csvExporter'
import checkStatus from 'components/hrmsTableTemplate/checkStatus'
// import pdfExporter from 'components/hrmsTableTemplate/pdfExporter'
import imageGallery from 'components/hrmsTableTemplate/imageGallery'
import _ from 'lodash'
import moment from 'moment'
import swal from 'sweetalert'
import labels from 'src/../config/label'
import { constLabels } from 'src/assets/js/constLabels.js'
import { numberFormat } from 'assets/js/numberFormat.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms-table',
  data () {
    return {
      app: this.$root.$children[0],
      dataTableRows: this.data.rows,
      dataTableTotal: this.data.rows.length,
      filterBodyColumns: this.getFilterBodyColumns(this.columns),
      button: labels.button,
      loadingBool: this.loadingParentBool,
      preLoadBool: this.preLoadParentBool,
      searchBool: this.searchParentBool,
      pageBool: false,
      windowWidth: 0,
      windowHeight: 0,
      deleteIconBool: false,
      deleteIconDesc: 'None',
      statusBtn: 'None',
      staapprBtn: 0,
      selectDesc: 'None',
      selectBtn: 0,
      radioAll: '',
      sortKey: '',
      inputSearch: '',
      selectedRows: this.value,
      currentPage: this.page,
      displayRowSelected: this.limit,
      displayRows: [ 5, 10, 25, 50, 100, 250, 500, 1000 ],
      flgInlineChange: false,
      summaryData: {}
    }
  },
  props: {
    value: {},
    columns: {
      type: Array,
      required: true,
      default () {
        return {
          key: '',
          name: ''
        }
      }
    },
    data: {
      type: Object,
      required: true,
      default: function () {
        return {
          total: 0,
          rows: []
        }
      }
    },
    loadingParentBool: {
      type: Boolean,
      default: false
    },
    preLoadParentBool: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value > 0
      }
    },
    limit: {
      type: Number,
      default: 10,
      validator: function (value) {
        return value > 0
      }
    },
    maxRowspan: {
      type: Number,
      default: 1
    },
    searchDisp: {
      type: Boolean,
      default: true
    },
    tablePageDisp: {
      type: Boolean,
      default: true
    },
    sortDisp: {
      type: Boolean,
      default: true
    },
    indexDisp: {
      type: Boolean,
      default: true
    },
    multiSelect: {},
    approveRowBool: {
      type: Boolean,
      default: false
    },
    approveBtnDisp: {
      type: Boolean,
      default: false
    },
    approveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    approveEvent: {
      type: Function
    },
    detailEvent: {
      type: Function
    },
    tickEvent: {
      type: Function
    },
    selectEvent: {
      type: Function
    },
    selectRowBool: {
      type: Boolean,
      default: false
    },
    selectBtnDisp: {
      type: Boolean,
      default: false
    },
    addBtnDisp: {
      type: Boolean,
      default: true
    },
    addEvent: {
      type: Function
    },
    editEvent: {
      type: Function
    },
    cancelEvent: {
      type: Function
    },
    backEvent: {
      type: Function
    },
    afterAddInlineEvent: {
      type: Function
    },
    afterEditInlineEvent: {
      type: Function
    },
    afterDeleteInlineEvent: {
      type: Function
    },
    columnEvent: {
      type: Function,
      default () {}
    },
    saveInlineEvent: {
      type: Function
    },
    addInlineEventBool: {
      type: Boolean,
      default: false
    },
    editInlineEventBool: {
      type: Boolean,
      default: false
    },
    deleteInlineEventBool: {
      type: Boolean,
      default: false
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    rowDisableCondition: {
      type: Function
    },
    rowClassCondition: {
      type: Function
    },
    deleteInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    deleteInlineBtnDisabledOlds: {
      type: Boolean,
      default: false
    },
    saveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    confirmSelectBtnDisp: {
      type: Boolean,
      default: true
    },
    summaryLabel: {
      type: String,
      default: ''
    },
    pdfExportDisp: {
      type: Boolean,
      default: false
    },
    csvExportDisp: {
      type: Boolean,
      default: false
    },
    flgToggle: {
      type: Boolean
    },
    addPreLoad: {
      type: Boolean,
      defalult: false
    },
    isLovTable: {
      type: Boolean,
      default: false
    }
  },
  created () {
    let createdBool = true
    this.setWatchData(createdBool)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  watch: {
    inputSearch () {
      this.dataTableRows = this.getDataTableRows()
    },
    selectedRows () {
      this.$emit('input', this.selectedRows)
    },
    displayRowSelected () {
      this.currentPage = 1 // Math.ceil(this.dataTableTotal / this.displayRowSelected)
    },
    loadingParentBool () {
      this.loadingBool = this.loadingParentBool
    },
    preLoadParentBool () {
      this.preLoadBool = this.preLoadParentBool
    },
    columns: {
      handler () {
        this.flgInlineChange = false
        this.filterBodyColumns = this.getFilterBodyColumns(this.columns)
        for (let row = 1; row <= this.filterBodyColumns.length; row++) {
          if (typeof this.filterBodyColumns[row - 1].sortNum === 'undefined') {
            this.$set(this.filterBodyColumns[row - 1], 'sortNum', 0)
          }
        }
      },
      deep: true
    },
    dataRows () {
      this.setWatchData()
    }
  },
  mounted () {
    this.$on('$saveInlineEventBuiltIn', () => {
      this.saveInlineEventBuiltIn()
    })
    this.$on('$selectEventBuiltIn', () => {
      this.selectEventBuiltIn()
    })
    this.$on('$clearTableInputSearch', () => {
      this.inputSearch = ''
    })
  },
  computed: {
    dataRows () {
      return this.data.rows
    },
    pcDisp () {
      return (this.windowWidth >= labels.pcWidth)
    },
    showPage () {
      return (this.pcDisp) ? 5 : 3
    },
    checkedAll: {
      get: function () {
        return this.dataTableRows ? this.selectedRows.length === this.dataTableRows.length : false
      },
      set: function (value) {
        let selectedRows = []
        if (value) {
          this.dataTableRows.forEach(function (dataRow) {
            selectedRows.push(dataRow)
          })
        }
        this.selectedRows = selectedRows
      }
    },
    displayRowSelectedComputed () {
      let displayRowSelected = (parseInt(this.displayRowSelected) <= this.dataTableTotal) ? parseInt(this.displayRowSelected) : this.dataTableTotal
      return displayRowSelected
    },
    startRow () {
      let startRow = (((this.currentPage - 1) * this.displayRowSelectedComputed) + 1)
      return startRow
    },
    endRow () {
      let endRow = (((this.currentPage - 1) * this.displayRowSelectedComputed) + this.displayRowSelectedComputed)
      return (endRow <= this.dataTableTotal) ? endRow : this.dataTableTotal
    },
    totalPage () {
      return Math.ceil(this.dataTableTotal / this.displayRowSelectedComputed)
    },
    noDataColumn () {
      let numColumn = this.filterBodyColumns.length
      numColumn = (this.indexDisp) ? ++numColumn : numColumn
      numColumn = (typeof this.multiSelect !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.approveEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.selectEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.tickEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.detailEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.approveEvent !== 'undefined' && !this.approveBtnDisp) ? --numColumn : numColumn
      numColumn = (typeof this.addEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.editEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.cancelEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (this.deleteInlineEventBool) ? ++numColumn : numColumn
      return numColumn
    },
    preSummaryColumn () {
      let numColumn = this.notPreSummaryColumn
      numColumn = (this.indexDisp) ? ++numColumn : numColumn
      numColumn = (typeof this.multiSelect !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.approveEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.selectEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.tickEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.detailEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.approveEvent !== 'undefined' && !this.approveBtnDisp) ? --numColumn : numColumn
      numColumn = (typeof this.addEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.editEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (typeof this.cancelEvent !== 'undefined') ? ++numColumn : numColumn
      numColumn = (this.deleteInlineEventBool) ? ++numColumn : numColumn
      return numColumn
    },
    notPreSummaryColumn () {
      let numColumn = 0
      for (let column of this.filterBodyColumns) {
        if (typeof column.summary === 'undefined') {
          numColumn = ++numColumn
        } else {
          if (column.summary) {
            break
          }
        }
      }
      return numColumn
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    }
  },
  methods: {
    getDataRowFromColumnDataType (data, dataType = 'string') {
      if (dataType === 'date') return assetsUtils.getDateOutput(data)
      if (dataType === 'year') return assetsUtils.getYearOutput(data)
      if (dataType === 'datetime') return assetsUtils.getDateTimeOutput(data)
      if (dataType === 'dateRange') return assetsUtils.getDateRangeOutput(data)
      return data
    },
    setWatchData (createdBool = false) {
      this.dataTableRows = this.getDataTableRows()
      this.initialLocalKeyOnDataTableRows()
      // this.setDisplayRowsSelected()
      if (!this.flgInlineChange) {
        this.setCurrentPage(1)
      } else {
        this.flgInlineChange = false
      }
      if (!createdBool) {
        if (!this.isLovTable) {
          this.loadingBool = false
        }
        this.$emit('setLoadingParentBool', false)
      }
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    // DataRows Methods
    initialLocalKeyOnDataTableRows () {
      if (this.addInlineEventBool ||
          this.editInlineEventBool ||
          this.deleteInlineEventBool ||
          typeof this.approveEvent !== 'undefined' ||
          typeof this.selectEvent !== 'undefined' ||
          typeof this.userStatusEvent !== 'undefined') {
        let row = 0
        for (let dataRow of this.dataTableRows) {
          row++
          this.$set(dataRow, 'rowID', row)
          if (this.addInlineEventBool) {
            this.$set(dataRow, 'flgAdd', dataRow.flgAdd || false)
          }
          if (this.editInlineEventBool) {
            this.$set(dataRow, 'flgEdit', dataRow.flgEdit || false)
          }
          if (this.deleteInlineEventBool) {
            this.$set(dataRow, 'flgDelete', dataRow.flgDelete || false)
            this.$set(dataRow, 'flgDeleteHide', dataRow.flgDeleteHide || false)
          }
          if (typeof this.approveEvent !== 'undefined') {
            this.$set(dataRow, 'flgStaappr', (typeof dataRow.flgStaappr === 'undefined') ? '' : dataRow.flgStaappr)
            this.$set(dataRow, 'staappr', (typeof dataRow.staappr === 'undefined') ? '' : dataRow.staappr)
          }
          if (typeof this.selectEvent !== 'undefined') {
            this.$set(dataRow, 'select', (typeof dataRow.select === 'undefined') ? '' : dataRow.select)
            this.$set(dataRow, 'flgSelect', '')
          }
          if (typeof this.userStatusEvent !== 'undefined') {
            this.$set(dataRow, 'userStatus', (typeof dataRow.userStatus === 'undefined') ? '' : dataRow.userStatus)
            this.$set(dataRow, 'flgact', '')
          }
        }
      }
    },
    setDisplayRowsSelected () {
      if (!this.tablePageDisp || this.addInlineEventBool || this.editInlineEventBool || this.deleteInlineEventBool) {
        this.displayRowSelected = 1000
      } else {
        this.displayRowSelected = (this.dataTableRows.length > 5) ? this.limit : 5
      }
    },
    getDataTableRows () {
      let _this = this
      let dataRows = []
      dataRows = this.dataRows.filter(function (dataRow, index) {
        if (!dataRow.flgDeleteHide || !_this.deleteInlineEventBool) {
          if (_this.inputSearch !== '') {
            for (let column of _this.filterBodyColumns) {
              let value = ''
              if (typeof column.inlineType !== 'undefined' && column.inlineType === 'select') {
                value = column.inlineDropdown[dataRow[column.key]]
              } else {
                value = dataRow[column.key]
              }
              if (typeof value === 'string') {
                if (value.toLowerCase().includes(_this.inputSearch.toLowerCase())) {
                  return true
                }
              } else if (typeof value === 'number') {
                if (value.toString().includes(_this.inputSearch)) {
                  return true
                }
              }
            }
          } else {
            return true
          }
        }
      })
      this.dataTableTotal = dataRows.length
      return this.sortData(dataRows)
    },
    resetOthersColumnSortKey (sortKey) {
      this.sortKey = sortKey
      for (let row = 1; row <= this.filterBodyColumns.length; row++) {
        if (this.filterBodyColumns[row - 1].key !== this.sortKey) {
          this.$set(this.filterBodyColumns[row - 1], 'sortNum', 0)
        }
      }
      this.dataTableRows = this.getDataTableRows()
    },
    sortData (dataRows) {
      let filterBodyColumns = this.filterBodyColumns
      for (let column of filterBodyColumns) {
        if (column.key === this.sortKey) {
          if (column.sortNum === 0) {
            return dataRows
          } else {
            let dataRowsSorted = dataRows.sort(function (dataRow1, dataRow2) {
              let dateRow1 = moment(dataRow1[column.key], 'DD-MM-YYYY HH:mm')
              let dateRow2 = moment(dataRow2[column.key], 'DD-MM-YYYY HH:mm')
              if (moment(dateRow1).isValid() && moment(dateRow2).isValid()) {
                return new Date(dateRow1) - new Date(dateRow2)
              } else {
                /*   return dataRow1[column.key] - dataRow2[column.key] //for number case */
                if (dataRow2[column.key] > dataRow1[column.key]) {
                  return -1
                }
                if (dataRow2[column.key] < dataRow1[column.key]) {
                  return 1
                }
                return 0
              }
            })

            if (column.sortNum === 1) {
              return dataRowsSorted
            } else if (column.sortNum === 2) {
              return dataRowsSorted.reverse()
            }
          }
        }
      }
      return dataRows
    },
    handleResize () {
      this.windowWidth = document.documentElement.clientWidth
      this.windowHeight = document.documentElement.clientHeight
    },
    displayRowsFilter () {
      let boolPass = true
      let newDisplayRows = []
      for (var displayRow of this.displayRows) {
        if (displayRow < this.dataTableTotal) {
          newDisplayRows.push(displayRow)
        } else {
          if (boolPass) {
            newDisplayRows.push(displayRow)
            boolPass = false
          }
        }
      }
      return newDisplayRows
    },
    filterPage (page) {
      let pageIndex = Math.ceil(this.currentPage / this.showPage)
      return (page >= (pageIndex - 1) * this.showPage + 1 && page <= pageIndex * this.showPage)
    },
    setPageClicked (page) {
      this.$validator.validateAll().then(result => {
        this.$emit('tableValid', true)
        if (result) {
          if (this.addInlineEventBool || this.editInlineEventBool || this.deleteInlineEventBool) {
            this.searchBool = false
            this.pageBool = false
          }
          this.setCurrentPage(page)
        }
      }).catch(() => {
        this.$emit('tableValid', false)
      })
    },
    setCurrentPage (page) {
      this.staapprBtn = 0 // reset Approve button
      this.currentPage = (page <= 0) ? 1 : (page > this.totalPage) ? this.totalPage : page
    },
    filterHeaderColumns (columns, headerRow) {
      let maxRowspan = this.maxRowspan
      return _.filter(columns, function (column) {
        column.headerRow = (typeof column.headerRow === 'undefined') ? 1 : parseInt(column.headerRow)
        column.colspan = (typeof column.colspan === 'undefined') ? 1 : parseInt(column.colspan)
        column.rowspan = (typeof column.rowspan === 'undefined') ? maxRowspan : parseInt(column.rowspan)
        return column.headerRow === headerRow
      })
    },
    getFilterBodyColumns (columns) {
      let columnHasNotOneSpan = _.filter(columns, function (column) {
        column.colspan = (typeof column.colspan === 'undefined') ? 1 : parseInt(column.colspan)
        return column.colspan > 1 || column.headerRow > 1 || column.rowspan > 1
      })

      let _this = this
      return _.filter(columns, function (column) {
        column.headerRow = (typeof column.headerRow === 'undefined') ? 1 : parseInt(column.headerRow)
        column.colspan = (typeof column.colspan === 'undefined') ? 1 : parseInt(column.colspan)
        column.rowspan = (typeof column.rowspan === 'undefined') ? _this.maxRowspan : parseInt(column.rowspan)
        if (columnHasNotOneSpan.length > 0) {
          return column.colspan === 1 && (column.headerRow !== 1 || column.rowspan !== 1) && (column.headerRow + column.rowspan - 1) === _this.maxRowspan
        } else {
          return column.colspan === 1
        }
      })
    },
    selectAllSelectInPage (flgSelect) {
      for (var i = this.startRow - 1; i < this.endRow; i++) {
        this.$set(this.dataTableRows[i], 'flgSelect', flgSelect)
      }
    },
    selectAllStatusInPage (flgStaappr) {
      for (var i = this.startRow - 1; i < this.endRow; i++) {
        if (!this.rowDisableConditionBuiltIn(this.dataTableRows[i])) {
          this.$set(this.dataTableRows[i], 'flgStaappr', flgStaappr)
        }
      }
    },
    countSelect () {
      this.selectBtn++
      if (this.selectBtn > 1) {
        this.selectBtn = 0
      }
      switch (this.selectBtn) {
        case 0:
          this.selectDesc = 'None'
          this.selectAllSelectInPage('N')
          break
        case 1:
          this.selectDesc = 'Chekced'
          this.selectAllSelectInPage('Y')
          break
      }
    },
    countStaappr () {
      this.staapprBtn++
      if (this.staapprBtn > 2) {
        this.staapprBtn = 0
      }
      switch (this.staapprBtn) {
        case 0:
          this.statusBtn = 'None'
          this.selectAllStatusInPage('')
          break
        case 1:
          this.statusBtn = 'Approve'
          this.selectAllStatusInPage('A')
          break
        case 2:
          this.statusBtn = 'Reject'
          this.selectAllStatusInPage('N')
          break
      }
    },
    toggleDelete (deleteIconBool) {
      this.deleteIconBool = deleteIconBool
      this.deleteIconDesc = (deleteIconBool) ? 'Delete' : 'None'
      this.selectAllDeleteInPage(deleteIconBool)
    },
    selectAllDeleteInPage (deleteIconBool) {
      for (var i = this.endRow - 1; i >= this.startRow - 1; i--) {
        if (!(this.rowDisableConditionBuiltIn(this.dataTableRows[i]) || (this.deleteInlineBtnDisabledOlds && !this.dataTableRows[i].flgAdd))) {
          this.dataTableRows[i].flgDelete = deleteIconBool
          if (this.dataTableRows[i].flgDelete && this.dataTableRows[i].flgAdd) {
            this.dataTableRows[i].flgDeleteHide = true
          }
        }
      }
    },
    eventTrigger (event, dataRow) {
      this.inputSearch = ''
      switch (event) {
        case 'tick':
          this.tickEvent(dataRow)
          break
        case 'add':
          this.addEvent()
          break
        case 'edit':
          if (this.rowDisableConditionBuiltIn(dataRow)) {
            let editEvent = this.editEvent
            swal({
              title: constLabels('confirmTitle'),
              text: constLabels('HR1490'),
              confirmButtonText: constLabels('ok'),
              closeOnConfirm: true,
              closeOnCancel: true,
              html: true
            },
            function (isConfirm) {
              if (isConfirm) editEvent(dataRow)
            })
          } else {
            this.editEvent(dataRow)
          }
          break
        case 'cancel':
          if (this.rowDisableConditionBuiltIn(dataRow)) {
            let cancelEvent = this.cancelEvent
            swal({
              title: constLabels('confirmTitle'),
              text: constLabels('HR1490'),
              confirmButtonText: constLabels('ok'),
              closeOnConfirm: true,
              closeOnCancel: true,
              html: true
            },
            function (isConfirm) {
              if (isConfirm) cancelEvent(dataRow)
            })
          } else {
            this.cancelEvent(dataRow)
          }
      }
    },
    addInlineEventBuiltIn () {
      this.searchBool = true
      this.pageBool = true
      this.inputSearch = ''
      let maxRowID = this.dataRows.map(function (dataRow) { return dataRow.rowID })
                                   .reduce(function (maxRowID, rowID) { return (maxRowID > rowID) ? maxRowID : rowID }, 0)
      let lastObj = this.dataRows[this.dataRows.length - 1]
      let newObj = {}
      if (this.dataTableRows.length === 0 || !_.isEmpty(lastObj, true) || (lastObj.flgDelete)) {
        for (var filterColumn of this.filterBodyColumns) newObj[filterColumn.key] = ''
        newObj.rowID = maxRowID + 1
        if (this.addInlineEventBool) {
          newObj.flgAdd = true
        }
        if (this.editInlineEventBool) {
          newObj.flgEdit = false
        }
        if (this.deleteInlineEventBool) {
          newObj.flgDelete = false
          newObj.flgDeleteHide = false
        }
        if (typeof this.approveEvent !== 'undefined') {
          newObj.staappr = (typeof newObj.staappr === 'undefined') ? '' : newObj.staappr
          newObj.flgstaappr = newObj.staappr
        }
        this.dataRows.push(newObj)
        this.data.total = this.dataRows.length + 1
        this.dataTableRows = this.getDataTableRows()
      }
      var page = (this.displayRowSelectedComputed % this.displayRowSelected === 0) ? this.totalPage + 1 : this.totalPage
      this.setCurrentPage(page)
      if (typeof this.afterAddInlineEvent !== 'undefined') {
        this.afterAddInlineEvent(newObj)
      }
    },
    onSelectChangeEditInlineAndColumnEvent (eventName, dataRow, event, key, rowIndex) {
      this.flgInlineChange = true
      this.editInlineEventBuiltIn(eventName, dataRow)
      let eventObj = event || { type: '', key: '' }
      this.columnEvent(eventName, dataRow, eventObj)
      this.$nextTick(() => {
        this.errors.clear()
      })
      // this.dataTableRows[rowIndex].mtrvalue = this.formatNumber(this.dataTableRows[rowIndex].mtrvalue)
    },
    columnEventBuiltIn (eventName, dataRow, eventObj) {
      this.flgInlineChange = true
      this.columnEvent(eventName, dataRow, eventObj)
    },
    formatNumber (total) {
      let valueNumber = total.replace(',', '')
      let neg = false
      if (valueNumber < 0) {
        neg = true
        valueNumber = Math.abs(valueNumber)
      }
      if (this.isNumeric(valueNumber)) {
        return (neg ? '-' : '') + parseFloat(valueNumber, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').toString()
      } else {
        return total
      }
    },
    isNumeric (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    },
    editInlineEventBuiltIn (eventName, dataRow) {
      if (!dataRow[eventName + '-flgEdit'] && !dataRow.flgAdd) {
        this.$set(dataRow, eventName + '-flgEdit', true)
        if (!dataRow.flgEdit) {
          this.searchBool = true
          this.pageBool = true
          this.inputSearch = ''
          this.$set(dataRow, 'flgEdit', true)
        }
      }
    },
    deleteInlineEventBuiltIn (flgDeleteHide = false) {
      for (var rowIndex = this.endRow - 1; rowIndex >= this.startRow - 1; rowIndex--) {
        let paramRow = this.dataTableRows[rowIndex]
        if (paramRow.flgDelete && flgDeleteHide) {
          let index = this.dataRows.map(function (dataRow) {
            return isNaN(dataRow.rowID) ? 0 : dataRow.rowID
          }).indexOf(paramRow.rowID)
          this.$set(this.dataRows[index], 'flgDeleteHide', true)
        }
      }
      let total = this.dataRows.filter(function (dataRow) {
        return !dataRow.flgDelete || !dataRow.flgDeleteHide
      }).length
      this.data.total = total

      this.setCurrentPage(1)
      this.deleteIconBool = false
      if (typeof this.afterDeleteInlineEvent !== 'undefined') {
        let dataRowsInline = this.findInlineDataHasFlg(this.dataRows)
        this.afterDeleteInlineEvent(dataRowsInline)
        // this.clearInlineDataRows('delete')
      }
    },
    saveInlineEventBuiltIn () {
      this.$validator.validateAll().then(result => {
        this.$emit('tableValid', true)
        if (result) {
          this.searchBool = false
          this.pageBool = false
          this.deleteInlineEventBuiltIn()
          if (typeof this.saveInlineEvent !== 'undefined') {
            let dataRowsInline = this.findInlineDataHasFlg(this.dataRows)
            this.saveInlineEvent(dataRowsInline)
            // this.clearInlineDataRows('save')
          }
        }
      }).catch(() => {
        this.$emit('tableValid', false)
      })
    },
    findInlineDataHasFlg (dataRows) {
      let dataRowsFilter = dataRows.filter(function (dataRow) {
        if (dataRow.flgAdd && dataRow.flgDelete) {
          return false
        } else {
          return (dataRow.flgAdd || dataRow.flgEdit || dataRow.flgDelete)
        }
      })
      let dataRowsNew = dataRowsFilter.map(function (dataRowFilter) {
        let dataRowNew = {}
        dataRowNew['flg'] = (dataRowFilter.flgAdd && !dataRowFilter.flgDelete) ? 'add'
                          : (dataRowFilter.flgEdit && !dataRowFilter.flgAdd && !dataRowFilter.flgDelete) ? 'edit'
                          : (dataRowFilter.flgDelete && !dataRowFilter.flgAdd) ? 'delete' : ''
        for (var key of Object.keys(dataRowFilter)) {
          if (key !== 'rowID' && key !== 'flgAdd' && key !== 'flgEdit' && key !== 'flgDelete' && key !== 'flgDeleteHide' && key !== 'flg') {
            dataRowNew[key] = dataRowFilter[key]
          }
        }
        return dataRowNew
      })
      return dataRowsNew
    },
    findDataSelected (dataRows) {
      return dataRows.filter(function (dataRow) {
        return dataRow.flgSelect === 'Y'
      })
    },
    clearInlineDataRows (flg) {
      for (var i = this.dataRows.length - 1; i >= 0; i--) {
        let dataRow = this.dataRows[i]
        if (flg === 'save') {
          dataRow.flgAdd = false
          dataRow.flgEdit = false
          dataRow.flg = ''
        }
        if (dataRow.flgDelete) {
          let index = this.dataRows.map(function (dataRow) {
            return dataRow.rowID
          }).indexOf(dataRow.rowID)
          this.$set(this.dataRows[i], 'flgDelete', true)
          this.dataRows.splice(index, 1)
        }
      }
      this.data.total = this.dataRows.length
    },
    findValidateRules (rules, rowIndex, dataRow, columnKey) {
      let targetRules = [
        'after',
        'before',
        'requiredWhenExist',
        'requiredWhenNotExist',
        'requiredAny',
        'requiredAllWhenExistAll',
        'requiredAllWhenExistAny',
        'requiredAllWhenNotExistAll',
        'requiredAllWhenNotExistAny',
        'requiredAnyWhenExistAll',
        'requiredAnyWhenExistAny',
        'requiredAnyWhenNotExistAll',
        'requiredAnyWhenNotExistAny',
        'date_between',
        'notDuplicate',
        'notMultiDuplicate',
        'max_ref'
      ]
      let singleParamRules = [
        'after',
        'before',
        'requiredIf',
        'lessThan',
        'greaterThan',
        'lessThanOrEqualTo',
        'greaterThanOrEqualTo',
        'requiredWhenExist',
        'requiredWhenNotExist',
        'requiredAny',
        'max_ref'
      ]
      let multiParamRules = [
        'requiredAllWhenExistAll',
        'requiredAllWhenExistAny',
        'requiredAllWhenNotExistAll',
        'requiredAllWhenNotExistAny',
        'requiredAnyWhenExistAll',
        'requiredAnyWhenExistAny',
        'requiredAnyWhenNotExistAll',
        'requiredAnyWhenNotExistAny'
      ]
      let tableRules = [
        'notDuplicate',
        'notMultiDuplicate'
      ]
      let arrRules = []
      if (typeof rules !== 'undefined') {
        arrRules = rules.split('|')
        for (let targetRule of targetRules) {
          let ruleIndex = arrRules.map(function (rule) {
            let mainRule = rule.split(':')
            return mainRule[0]
          }).indexOf(targetRule)
          if (ruleIndex > -1) {
            if (singleParamRules.indexOf(targetRule) > -1) {
              let arrRulesFromRuleIndex = arrRules[ruleIndex].split(':')
              let requiredParam = arrRulesFromRuleIndex[1]
              if (targetRule === 'requiredIf') {
                let arrRuleParams = requiredParam.split(',')
                let requireParam = arrRuleParams[0]
                requireParam = requireParam + rowIndex
                arrRules[ruleIndex] = arrRulesFromRuleIndex[0] + ':' + requireParam + ',' + arrRuleParams[1]
              } else if (targetRule === 'max_ref') {
                arrRules[ruleIndex] = 'max_value:' + dataRow[requiredParam].replace(/,/g, '')
              } else {
                requiredParam = requiredParam + rowIndex
                arrRules[ruleIndex] = arrRulesFromRuleIndex[0] + ':' + requiredParam
              }
            } else if (multiParamRules.indexOf(targetRule) > -1) {
              let arrRulesFromRuleIndex = arrRules[ruleIndex].split(':')
              let arrRuleParams = arrRulesFromRuleIndex[1].split(',')
              let arrRequireParams = arrRuleParams[0].split('-')
              let requireParams = ''
              let requireConcat = ''
              for (let requireParam of arrRequireParams) {
                requireParams += requireConcat + requireParam + rowIndex
                requireConcat = '-'
              }
              let arrWhenParams = arrRuleParams[1].split('-')
              let whenParams = ''
              let whenConcat = ''
              for (let whenParam of arrWhenParams) {
                whenParams += whenConcat + whenParam + rowIndex
                whenConcat = '-'
              }
              let ruleParams = requireParams + ',' + whenParams
              arrRules[ruleIndex] = arrRulesFromRuleIndex[0] + ':' + ruleParams
            } else if (tableRules.indexOf(targetRule) > -1) {
              if (targetRule === 'notDuplicate') {
                let elements = ''
                let concat = ''
                for (let indexRow = 0; indexRow < this.dataTableRows.length; indexRow++) {
                  let dataRow = this.dataTableRows[indexRow]
                  if (indexRow !== rowIndex && !dataRow.flgDelete) {
                    elements += concat + columnKey + indexRow
                    concat = ','
                  }
                }
                arrRules[ruleIndex] = arrRules[ruleIndex] + ':' + elements
              } else if (targetRule === 'notMultiDuplicate') {
                let arrRulesFromRuleIndex = arrRules[ruleIndex].split(':')
                let arrRuleKeys = arrRulesFromRuleIndex[1].split(',')
                let currentDataRow = this.dataTableRows[rowIndex]
                let valueConcat = ''
                let valueSet = ''
                for (let arrRuleKey of arrRuleKeys) {
                  let currentDataRowSplit = currentDataRow[arrRuleKey].split('-')
                  valueSet += valueConcat + currentDataRowSplit[0].replace(/ /g, '')
                  valueConcat = '-'
                }
                let targetFieldSet = ''
                let concat = ''
                for (let indexRow = 0; indexRow < this.dataTableRows.length; indexRow++) {
                  let dataRow = this.dataTableRows[indexRow]
                  for (let arrRuleKey of arrRuleKeys) {
                    if (indexRow !== rowIndex && !dataRow.flgDelete) {
                      targetFieldSet += concat + arrRuleKey + indexRow
                      concat = '-'
                    }
                  }
                }
                arrRules[ruleIndex] = arrRulesFromRuleIndex[0] + ':' + valueSet + ',' + targetFieldSet
              }
            } else {
              arrRules[ruleIndex] = arrRules[ruleIndex] + rowIndex
            }
          }
        }
      }

      return arrRules.join('|')

      // let arrRules = []
      // if (typeof rules !== 'undefined' && (dataRow.flgDelete || dataRow.flgAdd || dataRow.flgEdit)) {
      //   arrRules = rules.split('|')
      //   for (let targetRule of targetRules) {
      //     let ruleIndex = arrRules.map(function (rule) {
      //       let mainRule = rule.split(':')
      //       return mainRule[0]
      //     }).indexOf(targetRule)
      //     if (ruleIndex > -1) {
      //       if (multiParamRules.indexOf(targetRule) > -1) {
      //         let arrRulesFromRuleIndex = arrRules[ruleIndex].split(':')
      //         let arrRuleParams = arrRulesFromRuleIndex[1].split(',')
      //         let arrRequireParams = arrRuleParams[0].split('-')
      //         let requireParams = ''
      //         let requireConcat = ''
      //         for (let requireParam of arrRequireParams) {
      //           requireParams += requireConcat + requireParam + rowIndex
      //           requireConcat = '-'
      //         }
      //         let arrWhenParams = arrRuleParams[1].split('-')
      //         let whenParams = ''
      //         let whenConcat = ''
      //         for (let whenParam of arrWhenParams) {
      //           whenParams += whenConcat + whenParam + rowIndex
      //           whenConcat = '-'
      //         }
      //         let ruleParams = requireParams + ',' + whenParams
      //         arrRules[ruleIndex] = arrRulesFromRuleIndex[0] + ':' + ruleParams
      //       } else {
      //         if (targetRule === 'date_between') {
      //           let dteStart = dataRow[arrRules[ruleIndex].split(':')[1].split(',')[0]]
      //           let dteEnd = dataRow[arrRules[ruleIndex].split(':')[1].split(',')[1]]
      //           dteEnd = dteEnd !== '' ? dteEnd : '31/12/9999'
      //           arrRules[ruleIndex] = targetRule + ':' + dteStart + ',' + dteEnd
      //         } else {
      //           arrRules[ruleIndex] = arrRules[ruleIndex] + rowIndex
      //         }
      //       }
      //     }
      //   }
      // }
      // return arrRules.join('|')
    },
    rowDisableConditionBuiltIn (dataRow) {
      return (typeof this.rowDisableCondition !== 'undefined') ? this.rowDisableCondition(dataRow) : this.rowDisableBaseCondition(dataRow)
    },
    rowDisableBaseCondition (dataRow) {
      if (typeof dataRow.staappr !== 'undefined') {
        if (typeof this.approveEvent !== 'undefined') { // approve page
          return (!(dataRow.staappr === '' || dataRow.staappr === 'P' || dataRow.staappr === 'A') &&
                 (dataRow.staappr === 'C' || dataRow.staappr === 'Y' || dataRow.staappr === 'N'))
        } else { // request page
          return (!(dataRow.staappr === '' || dataRow.staappr === 'P' || dataRow.staappr === 'C') &&
                 (dataRow.staappr === 'A' || dataRow.staappr === 'Y' || dataRow.staappr === 'N'))
        }
      } else {
        return false
      }
    },
    detailEventBuiltIn (dataRow) {
      window.scrollTo(0, 0)
      this.detailEvent(dataRow)
    },
    selectEventBuiltIn () {
      if (typeof this.selectEvent !== 'undefined') {
        let selectedDataRows = this.findDataSelected(this.dataRows)
        this.selectEvent(selectedDataRows)
      }
    },
    numberConvertHourToSec (minInput) {
      let arrInput = minInput.trim().split(':')
      if (arrInput.length === 2) {
        let second = (isNaN(parseInt(arrInput[1])) ? 0 : parseInt(arrInput[1]))
        second += (isNaN(parseInt(arrInput[0])) ? 0 : parseInt(arrInput[0])) * 60
        return second
      }
      return 0
    },
    numberConvertSecToHour (minInput) {
      if (minInput !== '') {
        let hour = Math.floor(parseInt(minInput / 60))
        let min = minInput % 60
        return hour.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ':' + min.toString().padStart(2, '0')
      } else {
        return ''
      }
    },
    summaryDisp () {
      let summaryColumnCounted = this.columns.filter(function (column) {
        return (column.summary)
      }).length
      return summaryColumnCounted > 0
    },
    summaryColumn (column, isNotConvert = false) {
      let summary = 0
      if (this.dataTableRows.length > 0) {
        let _this = this
        summary = this.dataTableRows.filter((dataRow) => {
          return dataRow.flgBreak !== 'Y' && dataRow.flgsum !== 'Y'
        }).map(function (dataRow) {
          if (!dataRow.flgDelete) {
            let value = dataRow[column.key] + ''
            if (column.dataType === 'hour') {
              return _this.numberConvertHourToSec(value)
            }
            return isNaN(parseFloat(value.replace(':', '.').replace(/,/g, ''), 2)) ? 0 : parseFloat(value.replace(':', '.').replace(/,/g, ''), 2)
          } else {
            return 0
          }
        }).reduce(function (a, b) {
          return a + b
        })
      }
      if (column.summaryIsBlankWhenNull && summary === 0) {
        return ''
      }
      this.summaryData[column.key] = summary
      this.$emit('getSummaryData', this.summaryData)
      if (isNotConvert) {
        return summary.toString()
      }
      if (column.dataType === 'hour') {
        return this.numberConvertSecToHour(summary)
      }
      return numberFormat(summary)
    }
    // summaryColumn (column) {
    //   let summary = this.dataRows.map(function (dataRow) {
    //     return isNaN(parseFloat(dataRow[column.key].replace(/,/g, ''), 2)) ? 0 : parseFloat(dataRow[column.key].replace(/,/g, ''), 2)
    //   }).reduce(function (a, b) {
    //     return a + b
    //   })
    //   return numberFormat(summary)
    // }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    staapprButton,
    selectButton,
    deleteButton,
    sortColumn,
    csvExporter,
    // pdfExporter,
    imageGallery,
    checkStatus
  }
}
</script>

<style lang="scss">
.preLoad {
  font-size: 30px;
  padding-top: 50px;
}
td {
  position: relative;
}
.flg-inline {
  &.add {
    position: absolute;
    top: 0px;
    left: 0px;
    border: 5px solid red;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  &.edit {
    position: absolute;
    top: 0px;
    left: 0px;
    border: 5px solid #3c8dbc;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  &.delete, &.delete:hover {
    color: red !important;
    text-decoration: line-through;
  }
}
.main-del-unchecked {
  transition: background 0.3s ease;
  background:#FFF;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 30px;
  padding-left: 4px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  text-align: center;
  color:#757575;
  font-weight:700;
  font-size:20px;
}
.main-del-checked {
  transition: background 0.3s ease;
  background:#E53935;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 30px;
  padding-left: 4px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#FFF;
  font-size:20px;
}
.summary-row {
  border-top: 1px solid #757575;
  font-weight: bold;
  font-size: 16px;
}

.upload-on-table {

  .img-upload-preview {
    margin-right: 10px !important;
    img {
      max-width: 50px !important;
      max-height: 30px !important;
    }
  }

  .vue-dropzone {
    &.dropzone {
      min-height: 0;
      padding: 0;
      width: 100%;
      height: 35px;
      &.dz-clickable {
        .dz-default.dz-message {
          br {
            display: none;
          }
          .fa-cloud-upload:before {
            margin: 5px;
          }
          margin: 5px;
        }
        .dz-preview {
          background: none;
          margin: 0;
          min-height: 0;
          width: 100%;
          &:hover {
            .dz-remove {
              margin-left: 0;
              bottom: 0;
            }
          }
          .dz-image {
            width: 100% !important;
            height: 35px !important;
            img {
              width: 100%;
            }
          }
          .dz-details {
            padding: 3px;
            font-size: 10px;
            text-align: center;
            .dz-size {
              margin-bottom: 0;
              font-size: 10px;
            }
          }
          .dz-progress {
            height: 6px;
          }
          .dz-error-message {
            top: 0;
            left: 30%;
            &:after {
              left: 39px;
            }
          }
          .dz-success-mark {
            i {
              font-size: 16px !important;
            }
          }
          .dz-error-mark {
            i {
              font-size: 16px !important;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// component.vue?408d2e7e